import { render, staticRenderFns } from "./MyCompanyControlTape.vue?vue&type=template&id=4ca7a631&scoped=true&"
import script from "./MyCompanyControlTape.vue?vue&type=script&lang=js&"
export * from "./MyCompanyControlTape.vue?vue&type=script&lang=js&"
import style0 from "./MyCompanyControlTape.vue?vue&type=style&index=0&id=4ca7a631&lang=scss&scoped=true&"
import style1 from "./MyCompanyControlTape.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca7a631",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSelect})
